import { useMemo } from 'react';
import { css } from '@emotion/react';
import { AppointmentStatus } from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';
import { CheckListFilterSelector, FilterTraySection } from '@frontend/analytics-shared';
import { useTranslation } from '@frontend/i18n';
import { trackingIds } from '../../tracking-ids';
import { AppointmentStatusChip } from '../atoms/appointment-status-chips';

interface AppointmentStatusTrayFilterProps {
  value?: AppointmentStatus[];
  onChange: (status?: AppointmentStatus[]) => void;
}

export const AppointmentStatusTrayFilter = ({ value, onChange }: AppointmentStatusTrayFilterProps) => {
  const { t } = useTranslation('analytics');

  const statusOptions = useMemo(() => {
    return {
      [AppointmentStatus.APPOINTMENT_STATUS_CANCELLED]: (
        <AppointmentStatusChip status={AppointmentStatus.APPOINTMENT_STATUS_CANCELLED} css={styles.chipStyles} />
      ),
      [AppointmentStatus.APPOINTMENT_STATUS_NSR]: (
        <AppointmentStatusChip status={AppointmentStatus.APPOINTMENT_STATUS_NSR} css={styles.chipStyles} />
      ),
      [AppointmentStatus.APPOINTMENT_STATUS_COMPLETED]: (
        <AppointmentStatusChip status={AppointmentStatus.APPOINTMENT_STATUS_COMPLETED} css={styles.chipStyles} />
      ),
    };
  }, []);

  return (
    <FilterTraySection
      label={t('Appointment Status')}
      onReset={() => onChange(undefined)}
      disableReset={!value || value.length === 0}
    >
      <CheckListFilterSelector
        options={statusOptions}
        label={t('Appointment Status')}
        onChange={(statuses) => {
          onChange(statuses.length === 0 ? undefined : (statuses as AppointmentStatus[]));
        }}
        value={value || []}
        showLabel={false}
        trackingIdBase={`${trackingIds.filterTrayToggle}-status`}
      />
    </FilterTraySection>
  );
};

const styles = {
  chipStyles: css`
    max-width: none;
  `,
};
